import { apiconfig } from "src/config";
import reSourceService from "../ResourceService";
const urlEndpoint = "guest";
interface IFooterInfo {
  SettingName: string;
  SettingStringData: string;
}
const footerService = {
  Getfooterinfor: (): Promise<IFooterInfo[]> => {
    return reSourceService.get(`${urlEndpoint}/footerinfor`);
  },
  GetHeaderMenus: (): Promise<any> => {
    return reSourceService.get(`${urlEndpoint}/GetHeaderMenu`);
  },
  ExportExcelDanhSachPhong: async (data: any): Promise<any | null> => {
        const authorizationData = JSON.parse(localStorage.getItem("authorizationData") || "{}");
        let token = authorizationData?.Token;
        await fetch(
            `${apiconfig.baseURL}${urlEndpoint}/ExportExcelDanhSachPhong`,
            {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    apiKey: apiconfig.apiKey,
                    clientId: apiconfig.clientId,
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify(data),
            }
        ).then((response) => {
            if (response.ok) {
                response.blob().then((blob) => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = `DanhSachPhong`;
                    a.click();
                });
            }
        });
    },
    ExportExcelLookupTKB: async (data: any): Promise<any | null> => {
        const authorizationData = JSON.parse(localStorage.getItem("authorizationData") || "{}");
        let token = authorizationData?.Token;
        await fetch(
            `${apiconfig.baseURL}${urlEndpoint}/ExportExcelLookupTKB`,
            {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    apiKey: apiconfig.apiKey,
                    clientId: apiconfig.clientId,
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify(data),
            }
        ).then((response) => {
            if (response.ok) {
                response.blob().then((blob) => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = `DanhSachTKB`;
                    a.click();
                });
            }
        });
    },
    ExportExcelDataTraCuuTBKGiangVien: async (data: any): Promise<any | null> => {
        const authorizationData = JSON.parse(localStorage.getItem("authorizationData") || "{}");
        let token = authorizationData?.Token;
        await fetch(
            `${apiconfig.baseURL}${urlEndpoint}/ExportExcelDataTraCuuTBKGiangVien`,
            {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    apiKey: apiconfig.apiKey,
                    clientId: apiconfig.clientId,
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify(data),
            }
        ).then((response) => {
            if (response.ok) {
                response.blob().then((blob) => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = `DanhSachTKBGiangVien`;
                    a.click();
                });
            }
        });
    },
};
export default footerService;
